import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useGetAnswerKeyMutation } from '../../../../../features/authentication/assignApiSlice';
import html2pdf from 'html2pdf.js';
import ProgressButton from '../../../../../components/ProgressButton';

const AnswerKey = () => {
  const [getAnswerKey] = useGetAnswerKeyMutation();
  const [questionDetails, setQuestionDetails] = useState([]);
  const location = useLocation();
  const { assignmentName } = location.state;
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const { isAssessment, assignmentId } = useParams();

  const handleBackButtonClick = () => {
    window.history.back();
  };

  const handlePrintPDF = async () => {
    if(isPdfGenerating) return;

    setIsPdfGenerating(true);
    const contentWrapper = document.getElementById('answer-key-print');
    const contentClone = contentWrapper.cloneNode(true);
    const tables = contentClone.getElementsByTagName('table');

    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      table.style.pageBreakInside = 'avoid';
      table.style.breakInside = 'avoid';
      table.style.keepWithWindow = 'always';
    }

    const options = {
      margin: 40,
      filename: 'your-pdf-file.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'pt', format: 'a2', orientation: 'portrait' }
    };

    await html2pdf().set(options).from(contentClone).save(`${assignmentName}.pdf`);
    setIsPdfGenerating(false);
  };

  const getAnswerKeyAsync = async () => {
    const options = {
      assignmentId: assignmentId
    };
    const printAssignmentQuestionsResponse = await getAnswerKey(options).unwrap();
    setQuestionDetails(printAssignmentQuestionsResponse);
  };

  useEffect(() => {
    getAnswerKeyAsync();
  }, []);

  return (
    <div className="white-card">
      <div className="answerkey-wrapper">
        <div className="answerkey-header d-flex align-items-center justify-content-between">
          <h3>Answer Key</h3>
          <div className="d-flex gap-3 answerkey-btn justify-content-end">
            <button className="btn btn-castleWhite" onClick={handleBackButtonClick}>
              Back
            </button>
            <ProgressButton
              isLoading={isPdfGenerating}
              onClick={handlePrintPDF}
              loadingLabel="Generating PDF"
              label="Print to PDF"
              className="btn btn-castleRed"
              expectedDuration={1500}
            />
          </div>
        </div>
        <div className="keyPrint-content" id="answer-key-print">
          <div className="answerkey-content question-wrapper">
            <div className="d-flex align-items-center justify-content-between answerkey-head px-4">
              <div>
                <h4>{isAssessment?'Assessment ':'Assignment '}Name: <span>{assignmentName}</span></h4>
              </div>
              <div>
                <h4>Teacher Name: <span>{questionDetails?.teacherName}</span></h4>
              </div>
            </div>
            <div className="question-content row">
              {questionDetails?.answerKey?.map((item, index) => (
                <div key={`questionDetails${index}`} className="answer-keys">
                  <div className="mc-fill-answer">
                    {item.questionType === 'CR' ? (
                      <div>
                        <span>Question {item.questionNo} : CR</span>
                      </div>
                    ) : (
                      <div>
                        <span>Question {item.questionNo}</span> : <span className='flex-shrink-0' dangerouslySetInnerHTML={{ __html: item.answer }}></span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnswerKey;
